<template>
  <div>
    <van-tabs v-model="active" @click="onClick">
      <van-tab v-for="(type, index) in typeList" :key="index" :id="type.id" :title="type.name" :to="{ path: '/agency/orders', query: { status: type.id }}" >

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="orders-li" v-for="(item, k) in list" :key="k">
              <div class="o-li-title">
                <span class="o-li-title-l">{{ item.type_name }}</span>
                <span class="o-li-title-r">{{ item.status_name }}</span>
              </div>
              <div class="o-main">
                <div class="img">
                  <img :src="item.goods_image" />
                </div>
                <div class="info">
                  <h3>{{ item.goods_name }}</h3>
                  <div class="price">
                    <span>￥{{ item.goods_price }}</span>
                    <span class="right sp2">x{{ item.purchases }}</span>
                  </div>
                  <div class="pay-price">
                    <span class="p-sp-2">实付：￥{{ item.pay_price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>

      </van-tab>
    </van-tabs>

    <Floating toUrl="/agency/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Tab, Tabs, List, PullRefresh, CountDown } from 'vant'

  export default {
    components: {
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [CountDown.name]: CountDown,
      [PullRefresh.name]: PullRefresh,
    },
    name: 'agencyOrders',
    data () {
      return {
        page: 1,
        active: 0,
        typeList: [
          {id:0, name:'直属下级订单'},
          //{id:1, name:'间接下级订单'}
        ],
        list: [],
        listLength: 0,
        loading: false,
        finished: false,
        refreshing: false
      }
    },
    created () {
      //this.onLoad()
    },
    methods: {
      onLoad () {
        this.$api.get('agency/orders', {page: this.page, type: this.active}, r => {
          let data = r.data.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.last_page) {
            this.finished = true
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = 1
        this.list = []
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      onClick(name, title) {
        this.list = []
        this.page = 1
        this.onLoad()
      }
    }
  }
</script>

<style scoped>
  .orders-li{
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px;
    margin: 10px;
    padding:15px;
  }
  .orders-li .o-li-title{
    font-size: 14px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .orders-li .o-li-title .o-li-title-l{
    float: left;
    font-weight: bold;
  }
  .orders-li .o-li-title .o-li-title-r{
    float: right;
    color: #ED6A0C;
  }
  .orders-li .o-main{
    overflow: hidden;
  }
  .orders-li .o-main .img{
    float: left;
    width: 35%;
    height: 80px;
  }
  .orders-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .orders-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .orders-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 30px;
  }
  .orders-li .o-main .info .price{
    font-size: 14px;
  }
  .orders-li .o-main .info .price .sp2{
    color:#646566;
  }
  .orders-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .orders-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .orders-li .o-bottom{
    overflow: hidden;
    margin-top: 10px;
  }
  .orders-li .o-bottom .o-wl{
    float: right;
    font-size: 14px;
    border:1px solid #D3D3D3;
    border-radius: 15px;
    padding: 5px 20px;
    color:#6D6D6D;
    margin-left: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/orders.vue